const banner = require("../../images/egift/egift-purchase-history-card-background-en.png")
const LangEgiftPurchaseHistory = {
	"egiftPurchaseHistory._title": ["E-GIFT", "E-GIFT"],
	"egiftPurchaseHistory.header._card": ["CARD", "THẺ"],
	"egiftPurchaseHistory.header._purchased": ["PURCHASED", "ĐÃ MUA"],
	"egiftPurchaseHistory.header._received": ["RECEIVED", "ĐƯỢC NHẬN"],
	"egiftPurchaseHistory._banner": [banner, banner],
	"egiftPurchaseHistory.table._header1": ["DATE & TIME", "NGÀY GIỜ"],
	"egiftPurchaseHistory.table._header2": ["NAME OF FRIEND", "TÊN NGƯỜI NHẬN"],
	"egiftPurchaseHistory.table._header3": ["AMOUNT", "SỐ TIỀN"],
	"egiftPurchaseHistory.table._header4": ["STATUS", "TÌNH TRẠNG"],
	"egiftPurchaseHistory.table._purchasedNoAvailableRecord": [
		"There are no purchased history at the moment",
		"Tài khoản của bạn hiện chưa có giao dịch",
	],
	"egiftPurchaseHistory.table._receivedNoAvailableRecord": [
		"There are no received history at the moment",
		"Tài khoản của bạn hiện chưa có giao dịch",
	],
	"egiftPurchaseHistory.table.status._pendingVerification": [
		"Recipient acceptance pending",
		"Chờ xác nhận từ người nhận",
	],
	"egiftPurchaseHistory.table.status._expired": [
		"Gifts have been expired",
		"Quà đã hết hạn",
	],
	"egiftPurchaseHistory.table.status.purchased._expiredBetween30To60": [
		"Sender acceptance pending",
		"Chờ xác nhận từ người gửi",
	],
	"egiftPurchaseHistory.table.status._pendingUpdateProfileActive": [
		"Gifts have been received",
		"Quà đã được nhận",
	],
	"egiftPurchaseHistory.table.status._active": [
		"Enjoy your gift",
		"Tận hưởng món quà của bạn",
	],
	"egiftPurchaseHistory.table.status.purchased._active": [
		"Gifts have been received",
		"Qùa tặng đã được nhận",
	],
	"egiftPurchaseHistory.table.status._pendingUpdateProfile": [
		"Enjoy your gift",
		"Tận hưởng món quà của bạn",
	],
	"egiftPurchaseHistory.table.status.purchased._pendingUpdateProfile": [
		"Gifts have been received",
		"Qùa tặng đã được nhận",
	],
}

export default LangEgiftPurchaseHistory



// WEBPACK FOOTER //
// ./src/resources/modules/LangEgiftPurchaseHistory.js